import { render, staticRenderFns } from "./InformationGroupSelectCheckBoxes.vue?vue&type=template&id=5f1f04f8"
import script from "./InformationGroupSelectCheckBoxes.vue?vue&type=script&lang=ts"
export * from "./InformationGroupSelectCheckBoxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports